import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './list/list.component';
import { BulletListComponent } from './bullet-list/bullet-list.component';
import { FacebookListComponent } from './facebook-list/facebook-list.component';
import { LinkedinListComponent } from './linkedin-list/linkedin-list.component';
import { AvatarListComponent } from './avatar-list/avatar-list.component';
import { SkeletonCommonModule } from '../../common/components/common.module';
import { ParagraphModule } from '../../paragraph/components/paragraph.module';

@NgModule({
  declarations: [ListComponent, BulletListComponent, FacebookListComponent, LinkedinListComponent, AvatarListComponent],
  imports: [CommonModule, SkeletonCommonModule, ParagraphModule],
  exports: [ListComponent, BulletListComponent, FacebookListComponent, LinkedinListComponent, AvatarListComponent]
})
export class ListModule {}
